import { render, staticRenderFns } from "./ChallengeParentApprove.vue?vue&type=template&id=35b0b2ae&"
import script from "./ChallengeParentApprove.vue?vue&type=script&lang=js&"
export * from "./ChallengeParentApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports